<template>
    <div class="header-menus">
        <div class="menu-trangle"><img src="@/assets/img/trangle.png" /></div>
        <div class="menu-content">
            <div class="menu-item" v-for="(item, index) in tabData" :key="index" @click="menuClick(index)">
                <svg-icon class="icon" :icon-class="(item.iconClass.toLowerCase() + '_white')"></svg-icon>
                <div class="text">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "header-menus",
    data() {
        return {
            tabData: [{
                name: this.$t('text.home'),
                iconClass: 'home',
            },{
                name: this.$t('text.collections'),
                iconClass: 'collections',
            }
            // ,{
            //     name: this.$t('text.display'),
            //     iconClass: 'display',
            // }
            ,{
                name: this.$t('text.cases'),
                iconClass: 'cases',
            },{
                name: this.$t('text.account'),
                iconClass: 'account',
            }]
        }
    },
    methods: {
        menuClick(index) {
            let path = '';
            switch(index) {
                case 0: path = '/'; break;
                case 1: path = '/product-center'; break;
                case 2: path = '/template'; break;
                case 3: path = '/cases'; break;
                case 4: path = '/person'; break;
            }
            this.$router.push(path)
        }
    }
}
</script>

<style lang="scss" scoped>
.header-menus {
    position: fixed;
    top: 54px;
    right: 7px;
    width: 149px;
    z-index: 10;

    .menu-trangle {
        left: 107px;
        width: 11px;
        height: 7px;
        display: flex;
        position: relative;
    }

    .menu-content {
        background-color: #0B0F23;
        border-radius: 4px;
        margin-top: -1px;
        box-shadow: 0px 2px 15px 0px rgba(11,15,35,0.1);

        .menu-item {
            color: white;
            display: flex;
            height: 47px;
            align-items: center;

            .icon {
                width: 26px;
                color: red;
                margin: 0 16px;
            }

            .text {
                width: 100%;
                height: 100%;
                text-align: left;
                line-height: 48px;
                border-bottom: 1px solid rgba(255,255,255,0.1);

                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/menu.vue